import { theme } from '../../../../common/styles/theme';

// Speaker colors cycle through this palette, so a third (or unresolved) speaker never falls back
// to grey. The first two keep the colors the two-speaker case has always used.
export const SPEAKER_COLORS: string[] = [
	(theme.palette.secondary as any)[300],
	(theme.palette.secondary as any)[400],
	(theme.palette.secondary as any)[200],
	(theme.palette.primaryPurple as any)[400],
	(theme.palette.error.main as any)[400],
	(theme.palette.secondary as any)[100],
];
